//=====================================================
//　G003カレンダー操作ボタン
//=====================================================
import { useState } from "react";
import { useEffect } from "react";
import { useContext } from "react"
import { useHistory, useParams } from "react-router-dom";
import { CtxG003, G003MODE_MONTHLY, G003MODE_WEEKLY, IFG003Param } from "./G003"
import { useAuth } from "../../utils/UseAuth";
import { LoginStatusType } from "../../utils/ConstCommon"
import { formatDateMonth } from "../../utils/CommonFunc";
import { formatDateWeek } from "../../utils/CommonFunc";


interface IFProps{
    period: string
}

export function G003CalendarControl(props: IFProps) {

    const [prevVisible, setPrevVisible] = useState("");
    const [nextVisible, setNextVisible] = useState("");
    const ctx = useContext(CtxG003);
    const params = useParams<IFG003Param>();
    const history = useHistory();
    const ua = useAuth();

    //カレンダー操作処理
    function controlClick(addVal: number){
        if( ua.checkExpiresIn() === LoginStatusType.LoginExpired ){
            //ログイン期限切れ
            ua.logout(function(){history.push("/")});
        }else{
            //表示月・週設定
            let tmpDate:Date = new Date(ctx.cDate);
            if (params.mode === G003MODE_MONTHLY){
                //月表示の場合はひと月前後を設定
                tmpDate = getFirstDate(tmpDate);
                tmpDate.setMonth(tmpDate.getMonth() + addVal);
            } else {
                //週表示の場合は7日前後を設定
                tmpDate.setDate(tmpDate.getDate() + (addVal * 7));
                ctx.setMoveflg(true);
            }
            ctx.setCDate(tmpDate);
        }
    }

    //初回：カレンダーのボタンの表示制御
    useEffect(function(){
        let tmpPeriodDate:Date = new Date(Date.parse(props.period));
        if (params.mode === G003MODE_WEEKLY){
            //prevボタン
            let tmpLastWeekDate = new Date(ctx.cDate);
            tmpLastWeekDate.setDate(tmpLastWeekDate.getDate() - 4);
            if (formatDateWeek(tmpLastWeekDate) < formatDateWeek(new Date())){
                setPrevVisible(" is-visihidden");
            } else {
                setPrevVisible("");
            }
            //nextボタン
            let tmpNextWeekDate = new Date(ctx.cDate);
            tmpNextWeekDate.setDate(tmpNextWeekDate.getDate() + 4);
            if (formatDateWeek(tmpNextWeekDate) > formatDateWeek(tmpPeriodDate)){
                setNextVisible(" is-visihidden");
            } else {
                setNextVisible("");
            }
        } else {
            //prevボタン
            let tmpLastMonthDate = getFirstDate(new Date(ctx.cDate));
            tmpLastMonthDate.setMonth(tmpLastMonthDate.getMonth() - 1);
            if (formatDateMonth(tmpLastMonthDate) < formatDateMonth(new Date())) {
                setPrevVisible(" is-visihidden");
            } else {
                setPrevVisible("");
            }
            //nextボタン
            let tmpNextMonthDate = getFirstDate(new Date(ctx.cDate));
            tmpNextMonthDate.setMonth(tmpNextMonthDate.getMonth() + 1);
            if (formatDateMonth(tmpNextMonthDate) > formatDateMonth(tmpPeriodDate)){
                setNextVisible(" is-visihidden");
            } else {
                setNextVisible("");
            }
        }
    }, [ctx.cDate, params.mode, props.period]);

    return (

        <div className="calendar-control">
            <button className={"calendar-control-prev" + prevVisible} onClick={function(){controlClick(-1)}}></button>
            <div className="calendar-control-current text-l">{ctx.cDate.getFullYear() + "年" + (ctx.cDate.getMonth() + 1) + "月"}</div>
            <button className={"calendar-control-next" + nextVisible} onClick={function(){controlClick(1)}}></button>
            {params.mode === "weekly" && 
                <div className="caledar-control-right">
                    <div className="pc-parts">
                        <button className="btn btn-view-calendar-monthly" onClick={function(){history.push("/reservation/date/monthly")}}>カレンダー表示</button>
                    </div>
                    <div className="sp-parts">
                        <button className="btn btn-view-calendar-monthly" onClick={function(){history.push("/reservation/date/monthly")}}><span className="icon-calendar-select"></span></button>
                    </div>
                </div>
            }
        </div>

    )

}

//-----------------------------------------------------
//　引数の日付の月の初日を取得
//-----------------------------------------------------
function getFirstDate(val: Date): Date{

    let tmpDate = new Date(val);

    tmpDate.setDate(1);
    tmpDate.setHours(0);
    tmpDate.setMinutes(0);
    tmpDate.setSeconds(0);
    tmpDate.setMilliseconds(0);

    return tmpDate;

}

